export const mobileBreakpoint = 766;
